import isEmpty from 'lodash/isEmpty';
export var iterate = function iterate(obj, cb) {
  if (Array.isArray(obj)) {
    obj.forEach(cb);
  } else {
    Object.keys(obj).forEach(function (key) {
      return cb(obj[key], key);
    });
  }
};
var _mergeObjects = function mergeObjects(objects) {
  var combined = {};
  objects.forEach(function (object) {
    Object.keys(object).forEach(function (key) {
      combined[key] = combined[key] || [];
      combined[key] = combined[key].concat(object[key]);
    });
  });
  var result = {};
  Object.keys(combined).forEach(function (key) {
    var values = combined[key];
    var merged = typeof values[0] === 'string' ? values : _mergeObjects(values);
    if (!isEmpty(merged)) {
      result[key] = merged;
    }
  });
  return result;
};
export { _mergeObjects as mergeObjects };
export var unpackFn = function unpackFn(init, fn) {
  var result = fn;
  while (typeof result === 'function') {
    result = result(init);
  }
  return result;
};